import {initElements} from "../../define/shared"
import Splide from '@splidejs/splide'
import {Video} from '@splidejs/splide-extension-video'

export default function initSplit() {
    initElements(".split", split => {
        const splide = split.querySelector('.splide')
        const popup = split.querySelector('.split-popup')

        if (popup) {
            const button = {
                open: split.querySelector('[data-action="open-popup"]'),
                close: popup.querySelector('.icon-close')
            }

            button.open.addEventListener('click', () => {
                popup.classList.add('is--open')
            })

            button.close.addEventListener('click', () => {
                popup.classList.remove('is--open')
            })

            document.addEventListener('click', e => {
                if (popup.contains(e.target) && !popup.querySelector('.split-popup-wrapper').contains(e.target)) {
                    popup.classList.remove('is--open')
                }
            })
        }


        if (splide) {
            initSlider()
        }

        function initSlider() {
            const isSingle = split.querySelectorAll('.splide__slide').length === 1

            let slider = new Splide(splide, {
                arrows: !isSingle,
                pagination: !isSingle,
                drag: !isSingle,
                type: 'loop',
                speed: 700,
            })

            slider.mount({Video})

            const playButton = splide.querySelectorAll('.splide__video__play')

            if (playButton) {
                playButton.forEach(btn => {
                    btn.classList.add('icon', 'icon-play')
                })
            }
        }
    })
}
